var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [
            _vm._v("Contents - " + _vm._s(_vm.content.page_name))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.contentlist
        ? _c("div", { staticClass: "table-responsive" }, [
            _c(
              "table",
              { staticClass: "table table-bordered table-light" },
              _vm._l(_vm.contentlist, function(item) {
                return _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(item.content_id.replace(/_/g, " ")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.content_value))]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top-center",
                            value: _vm.tooltips.edit,
                            expression: "tooltips.edit",
                            modifiers: { "top-center": true }
                          }
                        ],
                        staticClass: "btn btn-info btn-sm",
                        on: {
                          click: function($event) {
                            return _vm.editContent(item)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-edit" })]
                    )
                  ])
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72523b02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72523b02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Tags/TagDetails.vue
// module id = u3Cn
// module chunks = 0